/* global ViewController, WebView */
var forgotPasswordPortalController = new ViewController({
    directory : "views/portal",
    name: "forgotPasswordPortal",
    container: "main",
    route: "portal-forgot-pass",
    openInPopup: true,
    popup: {
        size: "medium"
    }
}) ;

forgotPasswordPortalController.onValidate = function(){
    var login = this.view.getData().login ;

    this.view.longTask(function(done){
        this.api.public.sendPartnerPasswordForgot(login, function(err){
            if(err){ 
                if(err === "UNKOWN_CUSTOMER"){
                    err = this.view.tr("portal.unknownCustomerId") ;
                }else  if(err === "NO_ACCESS"){
                    err = this.view.tr("portal.noAccessForThisUser") ;
                }else  if(err === "NOT_ACTIVATED"){
                    err = this.view.tr("portal.notYetActivated") ;
                }
                return done(err) ;
            }
            this.view.info(this.view.tr("portal.passwordEmailSent")) ;
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = forgotPasswordPortalController ;